// extracted by mini-css-extract-plugin
export default {"heading":"DashboardDisabled_heading__YuCn3","button":"DashboardDisabled_button__oiBDN"};